import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=e05f4c14&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e05f4c14')) {
      api.createRecord('e05f4c14', component.options)
    } else {
      api.reload('e05f4c14', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=e05f4c14&", function () {
      api.rerender('e05f4c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PBGv31IYNWrr/JS/imageCarousel.vue"
export default component.exports